import { Switch as BaseSwitch } from '@base-ui/react/switch';
import { cn } from './cn';

/**
 * DESIGN.md › switch: a 44×24 track, grey off
 * and teal on, with a white thumb. `label` is the translated accessible name — the row's
 * text is next to it, but the control must name itself too.
 */
export function Switch({
  checked,
  onCheckedChange,
  label,
  disabled = false,
  className,
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label: string;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <BaseSwitch.Root
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      aria-label={label}
      className={cn(
        'relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full bg-action-primary-disabled p-0.5 transition-colors data-[checked]:bg-action-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-highlight disabled:cursor-not-allowed disabled:opacity-60',
        className,
      )}
    >
      <BaseSwitch.Thumb className="size-5 rounded-full bg-surface shadow-elevation-low transition-transform data-[checked]:translate-x-5" />
    </BaseSwitch.Root>
  );
}
